import { render } from "./Sorter.vue?vue&type=template&id=2347d2d9&scoped=true"
import script from "./Sorter.vue?vue&type=script&lang=js"
export * from "./Sorter.vue?vue&type=script&lang=js"

import "./Sorter.vue?vue&type=style&index=0&id=2347d2d9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2347d2d9"

export default script